import styles from './UpsertSchemeModal.module.css';

import { schemesStore } from '../../../../store/mobx/schemes.store';
import { useForm, FormProvider } from 'react-hook-form';
import Modal from '../../../../ui/Modal';
import useAlert from '../../../../hooks/useAlert';
import FormTextField from 'ui/formItems/FormTextField';

const UpsertSchemeModal = ({ setModalOpened }) => {
  const { upsertScheme, selectedScheme } = schemesStore;
  const { showAlert } = useAlert();

  const form = useForm({
    defaultValues: {
      name: selectedScheme?.name ?? '',
    },
  });

  const { handleSubmit } = form;

  const cancelClick = () => closeModal();

  const submitForm = async (data) => {
    const result = await upsertScheme({
      id: selectedScheme?.id,
      ...data,
    });

    if (!result.success && result.error_code === 2035) return alarmNameNotUniqueAlert();
    if (!result.success && result.error_code === 2040) return alarmNameNotUniqueAlert();
    if (!result.success && result.error_code)
      return errorCommonAlert(result.error_code, result.error);

    closeModal();
    successUpsertAlert();
  };

  const closeModal = () => {
    setModalOpened(false);
  };

  const alarmNameNotUniqueAlert = () => showAlert('Схема с таким именем уже существует!', 'error');

  const errorCommonAlert = (code, message) => {
    showAlert(` Код № ${code}${message ? ` - ${message}` : ''}!`, 'error');
  };

  const successUpsertAlert = () =>
    showAlert(
      selectedScheme?.id ? 'Схема обновлена успешно!' : 'Схема добавлена успешно!',
      'success',
    );

  return (
    <Modal
      title={`${selectedScheme?.id ? 'Редактировать' : 'Добавить'} схему`}
      onSubmit={handleSubmit(submitForm)}
      onClose={cancelClick}
    >
      <FormProvider {...form}>
        <FormTextField name={'name'} label={'Название'} required />
      </FormProvider>
    </Modal>
  );
};

export default UpsertSchemeModal;
